import { render, staticRenderFns } from "./DialogStatement.vue?vue&type=template&id=e6646eb4&scoped=true&"
import script from "./DialogStatement.vue?vue&type=script&lang=js&"
export * from "./DialogStatement.vue?vue&type=script&lang=js&"
import style0 from "./DialogStatement.vue?vue&type=style&index=0&id=e6646eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6646eb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VCard,VIcon,VTooltip})
